import React from "react";
import { Spin } from "antd";

const Spinner = props => {
	return (
		<div
			style={{
				position: "absolute",
				top: "50%",
				left: "50%",
				transform: "translate(-50%, -50%)",
				...props.style,
			}}
		>
			<Spin tip={props.tip || "Chargement en cours ..."} spinning={props.hasOwnProperty("spinning") ? props.spinning : true} />
		</div>
	);
};

export default Spinner;



// WEBPACK FOOTER //
// src/modules/stats/components/Spinner.js